import React, { useState } from "react";
import { Group, Image, Rect, Transformer } from "react-konva";
import useImage from "use-image";
import Trash from "assets/iconsSvg/trash.svg";

const Decoration = ({
  shapeProps,
  isSelected,
  onSelect,
  onChange,
  index,
  handleDragEnd,
  dragBoundFunc,
  onDeleteDecoration,
  editing,
}) => {
  const [isDraggable, setIsDraggable] = useState(false);
  const [isTransformer, setIsTransformer] = useState(false);

  const shapeRef = React.useRef();
  const trRef = React.useRef();

  React.useEffect(() => {
    if (isSelected) {
      trRef.current.nodes([shapeRef.current]);
      trRef.current.getLayer().batchDraw();
    }
  }, [isSelected]);

  const x = parseInt(shapeProps.posX);
  const y = parseInt(shapeProps.posY);
  const width = parseInt(shapeProps.width);
  const height = parseInt(shapeProps.height);
  const rotation = parseInt(shapeProps.rotation);

  const [trash] = useImage(Trash);

  return (
    <Group onTap={onSelect} key={shapeProps._id}>
      <Rect
        onClick={editing && onSelect}
        onTap={onSelect}
        ref={shapeRef}
        x={x}
        y={y}
        draggable={editing}
        width={width}
        height={height}
        rotation={rotation || 0}
        cornerRadius={5}
        fill="#FFF"
        onDragStart={() => {
          setIsDraggable(true);
        }}
        onDragEnd={(event) => {
          setIsDraggable(false);
          handleDragEnd(index, event, "decorations");
        }}
        onTransformStart={() => {
          setIsTransformer(true);
        }}
        dragBoundFunc={(pos) => dragBoundFunc(pos, width, height)}
        onTransformEnd={() => {
          setIsTransformer(false);
          const node = shapeRef.current;
          // const rotation = node.rotation();
          const scaleX = node.scaleX();
          const scaleY = node.scaleY();
          node.scaleX(1);
          node.scaleY(1);
          onChange({
            ...shapeProps,
            posX: node.x(),
            posY: node.y(),
            width: Math.max(5, node.width() * scaleX),
            height: Math.max(node.height() * scaleY),
            // rotation: rotation,
          });
        }}
      />
      {editing && !isDraggable && !isTransformer && (
        <Image
          image={trash}
          x={x + width - 15}
          y={y + 3}
          width={12}
          height={15}
          onClick={() => onDeleteDecoration(shapeProps)}
        />
      )}
      {isSelected && (
        <Transformer
          ref={trRef}
          flipEnabled={false}
          rotateEnabled={false}
          boundBoxFunc={(oldBox, newBox) => {
            // limit resize
            if (Math.abs(newBox.width) < 5 || Math.abs(newBox.height) < 5) {
              return oldBox;
            }
            return newBox;
          }}
        />
      )}
    </Group>
  );
};

export default Decoration;
